




















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { institutionServer, temporaryWorkServer } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';

@Component({
  components: {},
})
export default class TempList extends Vue {
  dialogVisible: any = false;
  tableData: any = [];

  queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  total: any = 0;

  loading: any = false;

  private filterForm: any = {
    companyId: '',
  };
  subSpaceByAuthOptions: any[] = [];

  showDialog(deptId: any) {
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.dialogVisible = true;
    this.filterForm.companyId = deptId || '';
    this.getSubSpaceByAuth();
    this.getListData();
  }
  getListData() {
    temporaryWorkServer
      .getTemporaryWorkPermit({
        current: (this.queryDataForm as any).pageNo,
        size: (this.queryDataForm as any).pageSize,
        companyId: this.filterForm.companyId,
      })
      .then((res: any) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  handleClose(done: any) {
    done();
  }

  private handleSizeChange(size: number) {
    this.queryDataForm.pageSize = size;
    this.getListData();
  }

  private handleCurrentChange(pageNo: number) {
    this.queryDataForm.pageNo = pageNo;
    this.getListData();
  }

  getSubSpaceByAuth() {
    // 发起接口请求，获取分页数据
    institutionServer
      .getDeptAndSubDeptList({})
      .then((res: any) => {
        this.subSpaceByAuthOptions = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  showDetail(item: any) {
    const refName = 'Dialog1Detail';
    const dialog = this.$refs[refName];
    (dialog as any).showDialog(item);
  }
}
